import { useLayoutEffect as c } from "react";
const u = (e, s, r) => {
  c(() => {
    const t = e.current;
    if (!r && t) {
      t.style.height = "0px";
      const o = t.scrollHeight;
      t.style.height = o + "px";
    }
  }, [r, e.current, s]);
};
export {
  u as useAutosizeTextArea
};
